import { ChangeEvent, forwardRef } from 'react';
import { Button, Divider, Stack, TextFieldProps } from '@mui/material';
import { useValidateInputField, ValidationTypes } from 'shared/hooks';

import { AmountStyledTextField } from '../styled';

type AmountInputProps = {
  initialState?: string;
  decimals: number;
  onChange: (value: string) => void;
  onMax?: () => void;
} & Omit<TextFieldProps, 'onChange'>;

export const AmountInput = forwardRef<HTMLInputElement, AmountInputProps>(
  ({ initialState, decimals, onChange, children, onMax, ...props }, ref) => {
    const [, handleChangeValue] = useValidateInputField({
      initialState: initialState || '',
      type: ValidationTypes.number,
      decimals,
    });

    const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const value = handleChangeValue(event);
      if (typeof value === 'string') {
        onChange?.(value);
      }
    };

    return (
      <AmountStyledTextField
        $error={!!props.error}
        onChange={handleChange}
        ref={ref}
        spellCheck={false}
        placeholder="0.00"
        fullWidth
        InputProps={{
          endAdornment: (
            <Stack direction="row" spacing={2}>
              {onMax && (
                <Button onClick={onMax} color="secondary" sx={{ minHeight: 32, fontWeight: '400' }}>
                  Max
                </Button>
              )}
              <Divider orientation="vertical" sx={{ height: 'auto' }} />
              {children}
            </Stack>
          ),
        }}
        {...props}
      />
    );
  },
);
